export default "__VITE_ASSET__Qj1AUP7n__$_?nuxt_component=async&nuxt_component_name=SvgoCell&nuxt_component_export=default__"